// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Cn-z","tupacHeader":"Dn-z","tupacHeader2":"En-z","tupacMenu":"Fn-z","tupacMenu2":"Gn-z","tupacMain":"Hn-z","tupacMain2":"In-z"};